import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=3b5bdf35&scoped=true&"
import script from "./Step2.vue?vue&type=script&lang=js&"
export * from "./Step2.vue?vue&type=script&lang=js&"
import style0 from "./Step2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Step2.vue?vue&type=style&index=1&id=3b5bdf35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5bdf35",
  null
  
)

export default component.exports